//
import { mapActions, mapState } from "vuex"
import { RForm } from "@/components/reusable_components/next"
import Translator from "@/services/translator"

//
import InventoryModel from "@/models/Warehouse/WhInventory"
import ProductModel from "@/models/Warehouse/WhProduct"
import ProductToSearchModel from "@/models/Warehouse/WhProductToSearch"

//
import fields from "./fields"
import InventoryFields from '@/views/Warehouse/WhInventory/WhInventoryFields'

//
export default {
    name: "inventory-create",
    components: {
        RForm,
    },
    computed: {

        //
        ...mapState( "AuthModule", [
            "user",
        ]),

        /**
         * @description
         * { function_description }
         *
         * @return     {Object}  { description_of_the_return_value }
         */
        dialogProps() {
            return {
                width: 720,
            }
        },

        /**
         *
         */
        formProps () {
            return {
                fields: fields({ 
                    g_branch_office_id          : this.user.hr_employee.g_branch_office_id,
                    g_branch_office_id_selected : this.branchOfficeId,
                    triggerWarehouse            : this.triggerWarehouse,
                }),
            }
        },

        uploadProps() {
            return {
                fields: InventoryFields,
            }
        },
    },
    data () {
        return {
            branchOfficeId: 1,
            dialog: false,
            formData: {
                wh_warehouse_id: '',
            },
        }
    },
    methods: {

        //
        ...mapActions("MenuesModule", [
            "setTitleTopBar",
        ]),

        //
        ...mapActions("SnackbarModalModule", [
            "resetSnackbarState",
            "setErrorSnackbar",
            "setInfoSnackbar",
            "setSuccessSnackbar",
            "setWarningSnackbar",
        ]),

        /**
         *
         */
        create ( model ) {
            model.toCreate().save().then( this.success ).then( this.redirect ).catch( this.error ).then( this.$refs.form.setWait )
        },

        /**
         *
         */
        redirect () {
            this.$router.push({ name: "inventory-list" })
        },

        /**
         * 
         */
        refreshSnackbar () {
            this.setInfoSnackbar( "Espere, refrescando stock esperado del detalle." )
        },

        /**
         * 
         */
        async refreshSelectedItem ( item ) {

            //
            let productData = await ProductModel.modeler().find( item.wh_product_id )

            //
            productData.g_branch_office_id  = this.branchOfficeId
            item.g_branch_office_id         = this.branchOfficeId
            item.expected_amount            = productData.stock_total || item.expected_amount || 0

            //
            return item
        },

        /**
         * 
         */
        async refreshSelected ( ctx ) {

            //
            const userEmployeeData          = this.user.hr_employee
                , warehouseInput            = ctx.getInput( "wh_warehouse_id" )
                , warehouseInputSelected    = warehouseInput.getSelected()
                , branchOfficeId            = warehouseInputSelected.g_branch_office_id || userEmployeeData.g_branch_office_id

            //
            this.branchOfficeId = branchOfficeId

            //          
            return Promise.all( this.formData.wh_selected_products.map( this.refreshSelectedItem ) )
        },

        /**
         *
         */
        reset () {
            this.branchOfficeId = this.user.hr_employee.g_branch_office_id
            this.formData       = new InventoryModel({ user: this.user })
        },

        /**
         *
         */
        error( error ) {
            this.setErrorSnackbar( Translator( InventoryModel, error.response.data ) )
        },

        /**
         * @description
         * Sets the details.
         */
        setDetails(res) {
            this.formData.wh_selected_products = res.data.details.map(this.formData.mapSelected)
        },

        /**
         *
         */
        success () {
            this.setSuccessSnackbar( "Inventario agregado." )
        },

        /**
         * @description
         * { function_description }
         *
         * @return     {<type>}  { description_of_the_return_value }
         */
        successUpload() {
            return this.setSuccessSnackbar('Detalle de inventario agregado.')
        },

        showUpload() {

        },

        /**
         *
         */
        submit () {
            this.$refs.form.setWait( true ).then( this.create )
        },

        /**
         * @description
         * { function_description }
         *
         * @return     {<type>}  { description_of_the_return_value }
         */
        submitFetchSkeleton() {
            return this.toWait(true).then(this.formData.fetchSkeletonExcel).then(this.toWait)
        },

        /**
         * @description
         * { function_description }
         *
         * @return     {<type>}  { description_of_the_return_value }
         */
        submitUpload() {
            return this.toWait(true).then(this.toUpload).then()
        },

        /**
         * @description
         * 
         */
        toggleDialog() {
            this.dialog ^= 1
        },

        /**
         * @description
         * { function_description }
         *
         * @param      {<type>}  model   The model
         * @return     {<type>}  { description_of_the_return_value }
         */
        toUpload(model) {

            //
            var fileData = new FormData()

            //
            fileData.append('file', this.$refs.upload.$el.file.files.item(0))
            fileData.append('g_branch_office_id', this.user.hr_employee.g_branch_office_id)

            //
            return this.formData
                .uploadFile('excel', fileData)
                .then(this.setDetails)
                .then(this.successUpload)
                .then(this.toggleDialog)
                .catch(this.error)
                .finally(this.toWait)
        },

        /**
         * @description
         * { function_description }
         *
         * @param      {boolean}  [value=false]  The value
         * @return     {<type>}   { description_of_the_return_value }
         */
        toWait(value = false) {
            return this.$refs.upload.setWait(value)
        },
    },
    watch: {
        'formData.wh_warehouse_id'(whWarehouseId) {
            ProductToSearchModel.global_wh_warehouse_id = whWarehouseId
        }
    },
    beforeMount() {
        this.setTitleTopBar( "Crear inventario" )
    },
    mounted() {
        this.reset()
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if ( ! ctx.$can( "CREATE_INVENTORY" ) ) ctx.$router.push( "/" )
        })
    },
}
